export enum FloorsContainerTypes {
  FloorsEventEmitter = 'FloorsEventEmitter',
  FloorsModalsFacade = 'FloorsModalsFacade',
  FloorsDataManager = 'FloorsDataManager',
}
